import { keyBy } from 'lodash'
import { callApi, getUrlWithPathParams } from 'services/api/utils'

import { ChecksConfig, InvestorCheck } from './types'

const INVESTOR_CHECKS_ENDPOINT_PATH = '/admin-investor-checks/'
const AVAILABLE_CHECKS_ENDPOINT_PATH = '/checks-config'

export async function apiGetInvestorChecks(): Promise<ApiIdIndexedInvestorChecks> {
  const investorChecksData = await callApi<ApiInvestorCheck[]>({
    url: INVESTOR_CHECKS_ENDPOINT_PATH,
  })
  return keyBy(investorChecksData, 'id')
}

export async function apiGetAvailableChecks(): Promise<ChecksConfig[]> {
  const availableChecksData = await callApi<ChecksConfig[]>({
    method: 'get',
    url: AVAILABLE_CHECKS_ENDPOINT_PATH,
  })
  return availableChecksData
}

export async function apiCreateInvestorCheck(investorCheck: Partial<ApiInvestorCheck>): Promise<ApiInvestorCheck> {
  return await callApi<ApiInvestorCheck>({
    method: 'post',
    url: INVESTOR_CHECKS_ENDPOINT_PATH,
    data: investorCheck,
  })
}

export async function apiUpdateInvestorCheck(investorCheck: Partial<ApiInvestorCheck>): Promise<ApiInvestorCheck> {
  const id = investorCheck.id ? investorCheck.id : ''
  return await callApi<ApiInvestorCheck>({
    method: 'put',
    url: getUrlWithPathParams(INVESTOR_CHECKS_ENDPOINT_PATH, id),
    data: investorCheck,
  })
}

export async function apiDeleteInvestorCheck(id: InvestorCheck['id']): Promise<InvestorCheck['id']> {
  await callApi<void>({
    method: 'delete',
    url: getUrlWithPathParams(INVESTOR_CHECKS_ENDPOINT_PATH, id),
  })
  return id
}

type ApiInvestorCheck = Partial<InvestorCheck>

type ApiIdIndexedInvestorChecks = {
  readonly [investorCheckId: string]: ApiInvestorCheck
}
